// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Voidrunner: Schiffsliste und Boss-Galerie im Spiel-Tab */

/* Screenshots klein neben dem Text statt darüber, damit die Anleitung kurz bleibt */
.vr-guide .product-tab-section {
  display: flow-root;
}

.vr-guide .product-tab-figure {
  max-width: 14rem;
}

@media (min-width: 700px) {
  .vr-guide .product-tab-figure {
    float: right;
    width: 12rem;
    margin: 0 0 0.75rem 1.5rem;
  }
}

.vr-ships {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 17rem), 1fr));
  gap: 0 1.25rem;
  margin: 1rem 0 0;
  padding: 0;
  list-style: none;
}

.vr-ship {
  display: grid;
  grid-template-columns: 4rem minmax(0, 1fr);
  gap: 0.75rem;
  align-items: start;
  padding: 0.75rem 0;
  border-top: 1px solid var(--border-primary);
}

/* Spielgrafik auf dunklem Grund wie auf der Uhr */
.vr-ship-img {
  position: relative;
  aspect-ratio: 1;
  background: #050808;
  border: 1px solid var(--border-primary);
}

.vr-ship-img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.vr-ship-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.2rem 0.75rem;
}

.vr-ship-head h4 {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.vr-ship-price {
  font-family: var(--font-mono);
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--tone-key);
  white-space: nowrap;
}

.content-tab-grid .product-tab-section p.vr-ship-needs {
  margin: 0.1rem 0 0;
  font-family: var(--font-mono);
  font-size: 0.74rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.vr-stats {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 0.25rem 0.7rem;
  margin: 0.5rem 0 0;
}

.vr-stats > div {
  display: contents;
}

.vr-stats dt {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.vr-stats dd {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  margin: 0;
}

.vr-bar {
  flex: 1;
  max-width: 7rem;
  height: 6px;
  background: var(--bg-tertiary);
}

.vr-bar > span {
  display: block;
  height: 100%;
  background: var(--accent-primary);
}

.vr-val {
  min-width: 2rem;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-primary);
}

.vr-slots {
  flex-wrap: wrap;
}

.vr-pips {
  display: inline-flex;
  gap: 3px;
}

.vr-pips i {
  width: 8px;
  height: 8px;
}

.vr-pips-w i {
  background: var(--tone-key);
}

.vr-pips-g i {
  background: var(--tone-air);
}

.vr-slot-text {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--text-secondary);
}

.content-tab-grid .product-tab-section p.vr-ship-trait {
  margin: 0.45rem 0 0;
  font-size: 0.88rem;
  color: var(--text-secondary);
}

.vr-ship-trait strong {
  color: var(--text-primary);
}

/* Boss-Galerie */
.vr-gallery {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.75rem;
  margin: 1rem 0 0;
}

@media (max-width: 700px) {
  .vr-gallery {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.vr-gallery figure {
  margin: 0;
  min-width: 0;
}

.vr-gallery img {
  display: block;
  width: 100%;
  height: auto;
}

.vr-gallery figcaption {
  margin-top: 0.35rem;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.03em;
  text-align: center;
  text-transform: uppercase;
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/customTabs/VoidrunnerTab.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D,oFAAoF;AACpF;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,OAAO;EACP,eAAe;EACf,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B","sourcesContent":["/* Voidrunner: Schiffsliste und Boss-Galerie im Spiel-Tab */\n\n/* Screenshots klein neben dem Text statt darüber, damit die Anleitung kurz bleibt */\n.vr-guide .product-tab-section {\n  display: flow-root;\n}\n\n.vr-guide .product-tab-figure {\n  max-width: 14rem;\n}\n\n@media (min-width: 700px) {\n  .vr-guide .product-tab-figure {\n    float: right;\n    width: 12rem;\n    margin: 0 0 0.75rem 1.5rem;\n  }\n}\n\n.vr-ships {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 17rem), 1fr));\n  gap: 0 1.25rem;\n  margin: 1rem 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.vr-ship {\n  display: grid;\n  grid-template-columns: 4rem minmax(0, 1fr);\n  gap: 0.75rem;\n  align-items: start;\n  padding: 0.75rem 0;\n  border-top: 1px solid var(--border-primary);\n}\n\n/* Spielgrafik auf dunklem Grund wie auf der Uhr */\n.vr-ship-img {\n  position: relative;\n  aspect-ratio: 1;\n  background: #050808;\n  border: 1px solid var(--border-primary);\n}\n\n.vr-ship-img img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.vr-ship-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.2rem 0.75rem;\n}\n\n.vr-ship-head h4 {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 1.15rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.vr-ship-price {\n  font-family: var(--font-mono);\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--tone-key);\n  white-space: nowrap;\n}\n\n.content-tab-grid .product-tab-section p.vr-ship-needs {\n  margin: 0.1rem 0 0;\n  font-family: var(--font-mono);\n  font-size: 0.74rem;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--text-tertiary);\n}\n\n.vr-stats {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 0.25rem 0.7rem;\n  margin: 0.5rem 0 0;\n}\n\n.vr-stats > div {\n  display: contents;\n}\n\n.vr-stats dt {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.vr-stats dd {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n  margin: 0;\n}\n\n.vr-bar {\n  flex: 1;\n  max-width: 7rem;\n  height: 6px;\n  background: var(--bg-tertiary);\n}\n\n.vr-bar > span {\n  display: block;\n  height: 100%;\n  background: var(--accent-primary);\n}\n\n.vr-val {\n  min-width: 2rem;\n  font-family: var(--font-mono);\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.vr-slots {\n  flex-wrap: wrap;\n}\n\n.vr-pips {\n  display: inline-flex;\n  gap: 3px;\n}\n\n.vr-pips i {\n  width: 8px;\n  height: 8px;\n}\n\n.vr-pips-w i {\n  background: var(--tone-key);\n}\n\n.vr-pips-g i {\n  background: var(--tone-air);\n}\n\n.vr-slot-text {\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  color: var(--text-secondary);\n}\n\n.content-tab-grid .product-tab-section p.vr-ship-trait {\n  margin: 0.45rem 0 0;\n  font-size: 0.88rem;\n  color: var(--text-secondary);\n}\n\n.vr-ship-trait strong {\n  color: var(--text-primary);\n}\n\n/* Boss-Galerie */\n.vr-gallery {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin: 1rem 0 0;\n}\n\n@media (max-width: 700px) {\n  .vr-gallery {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.vr-gallery figure {\n  margin: 0;\n  min-width: 0;\n}\n\n.vr-gallery img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.vr-gallery figcaption {\n  margin-top: 0.35rem;\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.03em;\n  text-align: center;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
